<template>
  <div class="summary-view">
    <div class="summary-grid">
      <SummaryIntro
        class="summary-intro"
        :entity-external-id="entityExternalId"
        :summary="entity.latest_fact_sheet?.summary"
      />
      <SummaryPersonalInformation
        class="summary-box"
        :entity="entity"
      />
      <SummaryCases
        v-if="advisorStore.hasFeature('Cases')"
        class="summary-box"
        :entity-external-id="entityExternalId"
      />
      <SummaryMeetings
        class="summary-meetings"
        :entity-external-id="entityExternalId"
      />
      <SummaryDocuments
        class="summary-box"
        :entity-external-id="entityExternalId"
      />
      <SummaryDossier
        class="summary-box"
        :entity-external-id="entityExternalId"
      />
      <SummaryPortfolio
        class="summary-box"
        :entity-external-id="entityExternalId"
      />
      <SummaryReports
        class="summary-reports"
        :entity-external-id="entityExternalId"
      />
    </div>
  </div>
</template>

<script setup>
import SummaryIntro from '@frontend/ui/features/summary/components/SummaryIntro.vue';
import SummaryPersonalInformation from '@frontend/ui/features/summary/components/SummaryPersonalInformation.vue';
import SummaryCases from '@frontend/ui/features/summary/components/SummaryCases.vue';
import SummaryMeetings from '@frontend/ui/features/summary/components/SummaryMeetings.vue';
import SummaryDocuments from '@frontend/ui/features/summary/components/SummaryDocuments.vue';
import SummaryDossier from '@frontend/ui/features/summary/components/SummaryDossier.vue';
import SummaryPortfolio from '@frontend/ui/features/summary/components/SummaryPortfolio.vue';
import SummaryReports from '@frontend/ui/features/summary/components/SummaryReports.vue';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';

const advisorStore = useAdvisorStore();

defineProps({
  entityExternalId: {
    type: String,
    required: true,
  },
  entity: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.summary-view {
  container-type: inline-size;
  container-name: summary-view-container;
}

.summary-grid {
  display: grid;
  padding: 1em 0;
  gap: 1em;
}

.summary-item {
  background: #fff;
  border-radius: 0.5em;
  border: 1px solid var(--stk-border);
  box-shadow: 0 0.125em 0.25em 0 rgb(0 0 0 / 2%), 0 0.0625em 0.125em 0 rgb(0 0 0 / 2%);
  padding: 1em;
}

.summary-box {
  min-height: 22em;
  overflow: hidden;
}

@container summary-view-container (width > 50em) {
  .summary-grid {
    grid-auto-flow: dense;
    grid-template-columns: repeat(3, 1fr);
  }

  .summary-meetings {
    grid-column: span 2;
  }

  .summary-intro,
  .summary-reports {
    grid-column: span 3;
  }
}
</style>
